export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Warm%20glowing%20abstract%20gradient%20background%20in%20soft%20peach%20coral%20and%20cream%20tones%2C%20organic%20flowing%20shapes%20blending%20into%20each%20other%2C%20gentle%20luminous%20quality%20with%20subtle%20sparkle%20accents%2C%20ethereal%20and%20uplifting%20atmosphere%2C%20premium%20sophisticated%20aesthetic%20with%20a%20dreamy%20feel%2C%20fine%20art%20photography%20style%20with%20bokeh%20effects%20and%20soft%20focus%20edges&width=1800&height=700&seq=cta-bg-2026-n3&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/35 to-black/50"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50 mb-4">
          Ready to Explore the <span className="text-primary-400">Kakobuy Spreadsheet</span>?
        </h2>
        <p className="text-base md:text-lg text-background-300 max-w-xl mx-auto mb-8 leading-relaxed">
          Thousands of product finds are waiting. Start discovering trending products organized by category today.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-10 py-3.5 bg-primary-500 text-background-50 rounded-md text-base font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer text-center"
          >
            Kakobuy Sheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-10 py-3.5 bg-background-50 text-foreground-950 rounded-md text-base font-semibold hover:bg-background-200 transition-all duration-200 whitespace-nowrap cursor-pointer text-center"
          >
            Buy It Now
          </a>
        </div>
      </div>
    </section>
  );
}